import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '../Box';

var Body = function Body(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "rowgroup",
    position: "relative",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    flexShrink: 1,
    flexGrow: 1,
    marginTop: "-1px",
    zIndex: 5,
    css: {
      '@media print': {
        overflowX: 'visible'
      }
    }
  }, props));
};

export default Body;